module.exports = __webpack_public_path__ + "images/triggers-default-f045e829.svg";